var _rect, _rect2, _rect3, _path, _circle, _rect4, _rect5, _rect6, _path2, _circle2, _rect7, _rect8, _rect9, _path3, _circle3, _path4, _circle4, _path5, _path6, _path7, _path8, _rect0, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a32bb7f9-696a-4ff4-93be-036c1dfea0ce",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 860.97572,
    height: 488.55421,
    viewBox: "0 0 860.97572 488.55421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 483.84895,
    y: 338.26917,
    width: 179.12677,
    height: 2.01266,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 483.84895,
    y: 352.35779,
    width: 179.12677,
    height: 2.01266,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 483.84895,
    y: 366.44641,
    width: 179.12677,
    height: 2.01266,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M691.41874,521.13752h-41.969V486.72288h41.969Zm-40.29029-1.67877H689.74v-31.0571H651.12845Z",
    transform: "translate(-169.51214 -205.7229)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 500.58796,
    cy: 298.55798,
    r: 8,
    fill: "#f9a826"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 483.84895,
    y: 57.26916,
    width: 179.12677,
    height: 2.01266,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 483.84895,
    y: 71.35778,
    width: 179.12677,
    height: 2.01266,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 483.84895,
    y: 85.4464,
    width: 179.12677,
    height: 2.01266,
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M691.41874,240.13749h-41.969V205.7229h41.969Zm-40.29029-1.67877H689.74V207.40165H651.12845Z",
    transform: "translate(-169.51214 -205.7229)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 500.58796,
    cy: 17.55799,
    r: 8,
    fill: "#f9a826"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 681.84895,
    y: 218.26917,
    width: 179.12677,
    height: 2.01266,
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 681.84895,
    y: 232.35777,
    width: 179.12677,
    height: 2.01266,
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 681.84895,
    y: 246.4464,
    width: 179.12677,
    height: 2.01266,
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M889.41874,401.13749h-41.969V366.72288h41.969Zm-40.29029-1.67877H887.74V368.40165H849.12845Z",
    transform: "translate(-169.51214 -205.7229)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 698.58796,
    cy: 178.55798,
    r: 8,
    fill: "#f9a826"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M379.16809,477.52227a5.336,5.336,0,0,0-3.67427,1.86262l-6.27448,7.30356-1.67914,1.95246a5.38559,5.38559,0,0,0,.56662,7.58395l27.82747,23.91819,49.35121,42.40461a5.386,5.386,0,0,0,7.317-.28207c.09511-.0937.17843-.18591.267-.28475l4.80336-5.58776,3.15531-3.67457a5.35159,5.35159,0,0,0,.65932-.95492,5.40586,5.40586,0,0,0,.625-2.95338,5.33539,5.33539,0,0,0-1.86271-3.67415l-5.8826-5.05747-43.52175-37.39992-27.769-23.872A5.3754,5.3754,0,0,0,379.16809,477.52227Z",
    transform: "translate(-169.51214 -205.7229)",
    fill: "#f9a826"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.10938,
    cy: 205.27559,
    r: 44.27213,
    fill: "#f9a826"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M353.28338,580.996H341.0738a5.382,5.382,0,0,0-5.37693,5.37693V688.12933a5.382,5.382,0,0,0,5.37693,5.37693h12.20958a5.382,5.382,0,0,0,5.37693-5.37693V586.373A5.382,5.382,0,0,0,353.28338,580.996Z",
    transform: "translate(-169.51214 -205.7229)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M379.08433,580.996H366.87475a5.382,5.382,0,0,0-5.37693,5.37693V688.12933a5.382,5.382,0,0,0,5.37693,5.37693h12.20958a5.37658,5.37658,0,0,0,5.37693-5.37693V586.373A5.37662,5.37662,0,0,0,379.08433,580.996Z",
    transform: "translate(-169.51214 -205.7229)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M378.5193,600.2976l-40.78362-1.06815A13.51824,13.51824,0,0,1,324.57284,585.298c.80761-26.0191,2.73321-82.32448,2.75217-82.87155a34.07411,34.07411,0,0,1,61.04055-20.83,33.657,33.657,0,0,1,7.13147,20.76718L409.30824,562.908a30.59871,30.59871,0,0,1-29.80367,37.40475C379.17741,600.31276,378.84808,600.30735,378.5193,600.2976Z",
    transform: "translate(-169.51214 -205.7229)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M405.57121,421.19152l-.43525-1.59682c2.97066-.8097,5.56192-1.6378,7.19167-3.56662a5.08575,5.08575,0,0,0,1.03006-4.10505,2.90713,2.90713,0,0,0-1.49186-2.10166c-1.58509-.7913-3.61414.0823-4.98488,1.16427l-1.182.93305-1.97715-19.26115,1.64579-.16865,1.68193,16.38416a5.84011,5.84011,0,0,1,5.55589-.5315,4.52568,4.52568,0,0,1,2.37256,3.24778,6.72752,6.72752,0,0,1-1.38664,5.50681C411.49743,419.575,408.21152,420.47121,405.57121,421.19152Z",
    transform: "translate(-169.51214 -205.7229)",
    fill: "#2f2e41"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 386.31545,
    y: 397.50669,
    width: 8.91039,
    height: 1.65444,
    transform: "translate(-252.49192 -102.23155) rotate(-13.65272)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M348.93239,483.21036a5.336,5.336,0,0,0-3.73905-1.72891l-9.62047-.397-2.573-.10755a5.3856,5.3856,0,0,0-5.6003,5.14529l-1.522,36.66241-2.68847,65.01126a5.386,5.386,0,0,0,4.75652,5.56717c.13248.01656.25648.02479.389.03307l7.36218.30607,4.83932.19858a5.35088,5.35088,0,0,0,1.158-.07448,5.40576,5.40576,0,0,0,2.705-1.34009,5.33536,5.33536,0,0,0,1.72876-3.73905l.32273-7.751L348.825,523.6614l1.522-36.58794A5.37532,5.37532,0,0,0,348.93239,483.21036Z",
    transform: "translate(-169.51214 -205.7229)",
    fill: "#f9a826"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M341.88446,475.18631a14.96361,14.96361,0,0,0-3.12712-.32263,15.32205,15.32205,0,0,0-15.30357,15.30358v28.12549a5.39984,5.39984,0,0,0,2.4239,4.4918,5.29966,5.29966,0,0,0,2.00181.79415,5.15323,5.15323,0,0,0,.95122.091H348.684a.76093.76093,0,0,0,.141-.00828,5.3734,5.3734,0,0,0,5.236-5.36865V490.16726A15.32775,15.32775,0,0,0,341.88446,475.18631Z",
    transform: "translate(-169.51214 -205.7229)",
    fill: "#2f2e41"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M410.32845,496.1646l-21.76381-17.81007a15.3043,15.3043,0,0,0-19.39039,23.68332l21.76421,17.81007a5.374,5.374,0,0,0,6.79993.00828,4.45638,4.45638,0,0,0,.769-.76107l12.57391-15.36144a5.317,5.317,0,0,0,.98435-1.82817A5.40579,5.40579,0,0,0,410.32845,496.1646Z",
    transform: "translate(-169.51214 -205.7229)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M365.06454,384.10221c7.89186,1.243,16.412,2.6694,24.13234-.17451,6.32478-2.32983,11.65376-7.653,11.51953-14.73992-.12827-6.77191-4.71674-12.75422-10.48045-15.91123-6.51981-3.57115-14.46061-4.13623-21.73459-3.42127-4.39469.432-9.12475,1.53976-12.5593,4.48019-2.74919,2.35368-4.86882,5.9168-4.47485,9.653l-3.21138-.08422c1.2527-4.12724-.8291-8.25506-3.97305-10.92548-3.78018-3.21082-8.9308-3.67927-13.63453-2.68037-9.56654,2.03158-18.21587,8.80091-24.56936,15.99465a60.92028,60.92028,0,0,0-13.17738,24.7178c-2.70235,10.2772-2.767,21.7973,1.38811,31.7049,4.229,10.08382,13.43459,18.39141,24.70768,18.99766,2.13316.11472,2.04458,3.44268-.10225,3.32722-10.76159-.57874-20.27928-7.46383-25.53033-16.67645-6.03419-10.58657-6.81244-23.59705-4.35291-35.33845a64.21923,64.21923,0,0,1,13.69467-27.894c6.766-8.07729,16.26122-15.559,26.702-17.96655,5.999-1.38331,12.31071-.65855,17.12706,3.38323,4.11206,3.45076,6.515,9.01891,4.90912,14.30981-.44083,1.45241-3.02957,1.64-3.21138-.08421-.9219-8.74281,6.21515-15.08606,14.05991-17.19057a45.5518,45.5518,0,0,1,13.6142-1.24893,38.9948,38.9948,0,0,1,12.30272,2.37153c7.44324,2.86346,13.63688,8.81886,15.38425,16.795,1.74322,7.95723-2.11122,15.331-8.93193,19.46623-9.00143,5.45742-19.82305,4.0179-29.70016,2.46216a1.72175,1.72175,0,0,1-1.61249-1.71473,1.67318,1.67318,0,0,1,1.71473-1.61249Z",
    transform: "translate(-169.51214 -205.7229)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M551.51214,694.2771h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-169.51214 -205.7229)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService3);
export default __webpack_public_path__ + "static/media/service3.4e6bdeefa409b7fabf9c3f308b7d62e6.svg";
export { ForwardRef as ReactComponent };